/**
 * Одна ответственность: список поддерживаемых локалей и проверка/извлечение локали из пути.
 * Единый источник — I18nService.
 */

import { I18nService } from '@/domain/services/i18n.service'
import { I18nRepository } from '@/infrastructure/repositories/i18n.repository'

function getService() {
  return I18nService.getInstance(I18nRepository.getInstance())
}

export function getSupportedLocales(): readonly string[] {
  return getService().getSupportedLocales()
}

export function isValidLocale(locale: string): boolean {
  return getSupportedLocales().includes(locale)
}

export function extractLocaleFromPath(path: string): string | null {
  const segment = path.split('/').filter(Boolean)[0]
  return segment && isValidLocale(segment) ? segment : null
}
